import api from "utils/api";

// API 경로 상수 정의
const APP_API_URL = process.env.REACT_APP_API_URL;

// 스포츠 종류 조회
export const getSportsTypes = async () => {
    try {
        const res = await api.get(`/buccl_main/api/v1/sports/`);
        return res.data;
    } catch (error) {
        return [];
    }
};

//잠수풀 상세 정보 조회
export const getDivingPoolsInfo = async (poolId) => {
    try {
        const res = await api.get(
            `${APP_API_URL}/buccl_main/api/v1/locations/${poolId}/`
        );
        return res.data;
    } catch (error) {
        return { locations: [], count: 0, filters: {} };
    }
};

//잠수풀 목록 조회
export const getLocationList = async () => {
    try {
        const res = await api.get(
            `${APP_API_URL}/buccl_main/api/v1/locations/`
        );
        return res.data;
    } catch (error) {
        return { locations: [], count: 0, filters: {} };
    }
};

//강습 일정 조회
export const getClassSchedule = async (params) => {
    try {
        const queryParams = new URLSearchParams(params).toString();
        const res = await api.get(
            `${APP_API_URL}/buccl_lessons/api/v1/instructor-schedules/?${queryParams}`
        );
        return res.data;
    } catch (error) {
        console.error("getClassSchedule API 에러:", error);
        return [];
    }
};

//강습 상세 조회
export const getClassScheduleDetail = async (scheduleId) => {
    try {
        const res = await api.get(
            `${APP_API_URL}/buccl_lessons/api/v1/instructor-schedules/${scheduleId}/`
        );
        return res.data;
    } catch (error) {
        console.error("getScheduleDetail API 에러:", error);
        throw error;
    }
};

//연습반 상세 조회
export const getPracticeScheduleDetail = async (scheduleId) => {
    try {
        const res = await api.get(
            `${APP_API_URL}/buccl_lessons/api/v1/practice-schedules/${scheduleId}/`
        );
        return res.data;
    } catch (error) {
        console.error("getScheduleDetail API 에러:", error);
        throw error;
    }
};

export const getPracticeSchedule = async (params) => {
    try {
        const queryParams = new URLSearchParams(params).toString();
        const res = await api.get(
            `${APP_API_URL}/buccl_lessons/api/v1/practice-schedules/?${queryParams}`
        );
        return res.data;
    } catch (error) {
        console.error("getPracticeSchedule API 에러:", error);
        return [];
    }
};

// 강습 예약 취소
export const cancelReservation = async (type, scheduleId) => {
    // BE 는 성공 응답에도 message 를 담아주므로(예: "…성공적으로 취소되었습니다")
    // 성공/실패는 message 유무가 아니라 success 플래그로 판정한다.
    // 성공 응답의 payment_cancel_warning 은 PG 환불 실패 경고(예약 취소는 완료됨).
    try {
        const pacticeQuery =
            type === "practice" ? "?is_free_practice=true" : "";

        const res = await api.post(
            `/buccl_lessons/api/v1/cancel-session/${scheduleId}/${pacticeQuery}`
        );
        return { success: true, ...res.data };
    } catch (error) {
        return {
            success: false,
            message: error.response?.data.error || "취소 요청 실패",
        };
    }
};

// 강습 예약 등록
// type: lesson, practice
export const postReservation = async (type, scheduleId) => {
    try {
        const pacticeQuery =
            type === "practice" ? "?is_free_practice=true" : "";
        const res = await api.post(
            `/buccl_lessons/api/v1/apply-session/${scheduleId}/${pacticeQuery}`
        );
        return res;
    } catch (error) {
        // 에러 객체 전체를 반환하여 recommended_products, code 등 포함
        return error;
    }
};

// 연습반 PENDING 예약 결제 완료 (BE PR #365)
export const applyPracticeSchedule = async (scheduleId) => {
    try {
        const res = await api.post(
            `/buccl_lessons/api/v1/practice-schedules/${scheduleId}/apply/?is_free_practice=true`
        );
        return res;
    } catch (error) {
        return error;
    }
};

//생성한 코스 승인API
export const approveCourese = async (data, courseId) => {
    try {
        const res = await api.put(
            `/approve-sports-schedule/${courseId}/`,
            data
        );
        return res;
    } catch (error) {
        console.error("코스 승인 중 오류 발생:", error);
    }
};

// 강습 삭제
export const deleteLessonProduct = async (id) => {
    return await api.post(`/buccl_lessons/api/v1/instructor-schedules/${id}/cancel/`);
};

//연습반 삭제
export const deletePracticeProduct = async (id) => {
  return await api.patch(`/buccl_lessons/api/v1/practice-schedules/${id}/`, { status: "CANCELLED" });
};



//수강권 상품 목록 조회
export const getClassProduct = async (id) => {
    // 단건 상세는 실패(404·숨김 상품 등) 시 null 을 반환해
    // 목록 조회 실패([])와 구분한다. 호출부는 null 이면 에러 화면을 보여준다.
    if (id) {
        try {
            const res = await api.get(
                `/buccl_lessons/api/v1/lesson-products/${id}/`
            );
            return res.data;
        } catch (err) {
            console.error("getClassProduct API 에러:", err);
            return null;
        }
    }
    try {
        const res = await api.get(`/buccl_lessons/api/v1/lesson-products/`);
        return res.data;
    } catch (err) {
        console.error("getClassProduct API 에러:", err);
        return [];
    }
};

// 특강 하위 탭 등 스포츠별 상품 목록 조회.
// 단건 상세(getClassProduct)와 URL 계약이 다르므로 함수를 분리한다 (73ff498 회귀 방지).
export const getClassProductsBySport = async (sportId) => {
    try {
        const res = await api.get(
            `/buccl_lessons/api/v1/lesson-products/?sport=${sportId}`
        );
        return res.data;
    } catch (err) {
        console.error("getClassProductsBySport API 에러:", err);
        return [];
    }
};

export const getAssociationList = async () => {
    try {
        const res = await api.get(`/buccl_lessons/api/v1/associations/`);
        return res.data;
    } catch (error) {
        return [];
    }
};
